/* Item-score diamond: four facets, lit from the top. */
export const ItemScoreDiamond = ({ size = 15 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    aria-hidden
    className="shrink-0"
  >
    <path d="M0 8L8 0V8Z" fill="#53fede" />
    <path d="M8 0L16 8H8Z" fill="#8effea" />
    <path d="M0 8H8V16Z" fill="#21644f" />
    <path d="M8 8H16L8 16Z" fill="#3ca787" />
  </svg>
);
